let mixin={
    data(){
      return{
        pageState: {
            state: 'loading',
            message: ''
          },
          
      };
    },
    methods:{
       setPageState(state, message) {
        this.pageState.state = state;
        this.pageState.message = message;
      }

    },
    mounted() {
      
    }
  };
  export default mixin;


// WEBPACK FOOTER //
// ./src/mixins/page-mixer.js